/**
 * @author: Real Links <engineering@reallinks.io> (https://real-links.github.io)
 * @license: © 2020 Real Links Limited
 * @link: https://real-links.github.io
 *
 * Wrap around Cognito functions to resolve the async nature
 */
import { CognitoAuth } from 'amazon-cognito-auth-js';

export default class CognitoSensibleAuth extends CognitoAuth {

  constructor(data, userhandler = {}) {
    super(data);
    this.userhandler = userhandler;
  }

  getRefreshToken() {
    const session = this.signInUserSession || this.getCachedSession();
    const refreshToken = session ? session.getRefreshToken() : null;
    return refreshToken ? refreshToken.getToken() : null;
  }

  async getSession(...args) {
    try {
      const result = await new Promise((resolve, reject) => {
        this._wrapHandlers({ resolve, reject });
        super.getSession(...args);
      });
      return result;
    } finally {
      this._resetHandlers();
    }
  }

  async refreshSession(...args) {
    try {
      const result = await new Promise((resolve, reject) => {
        this._wrapHandlers({ resolve, reject });
        super.refreshSession(...args);
      });
      return result;
    } finally {
      this._resetHandlers();
    }
  }

  async parseCognitoWebResponse(...args) {
    try {
      const result = await new Promise((resolve, reject) => {
        this._wrapHandlers({ resolve, reject });
        super.parseCognitoWebResponse(...args);
      });
      return result;
    } finally {
      this._resetHandlers();
    }
  }

  _wrapHandlers({ resolve, reject }) {
    const self = this;
    self._userhandler = { ...self.userhandler };
    self.userhandler = {
      onSuccess(result) {
        if (self._userhandler && self._userhandler.onSuccess) {
          self._userhandler.onSuccess(result);
        }
        resolve(result);
      },
      onFailure(err) {
        if (self._userhandler && self._userhandler.onFailure) {
          self._userhandler.onFailure(err);
        }
        reject(err);
      },
    };
  }
  _resetHandlers() {
    this.userhandler = { ...this._userhandler };
    this._userhandler = null;
  }

}



// WEBPACK FOOTER //
// ./src/lib/cognito.js